import SomethingWentWrong from './somethingWentWrong'

export default SomethingWentWrong
